import ru from './ru.svg';
import gb from './gb.svg';
import es from './es.svg';
import kg from './kg.svg';

const flags = {
  ru,
  gb,
  es,
  kg,
}

export default flags
